<template>
    <div>
        <div class="edit-row">
            <div class="details-title">Name</div>
            <div>
                <el-button
                    v-if="canEdit"
                    type="primary"
                    class="gcmcn-primary-btn small"
                    @click="editDetails"
                >Edit</el-button>
                <el-button
                    v-else
                    type="primary"
                    :loading="true"
                    class="gcmcn-primary-btn small"
                >Retrieving</el-button>

                <el-popover
                    ref="popover"
                    placement="bottom"
                    width="148"
                    trigger="click"
                    popper-class="dark-popper"
                    @hide="hideDeletePopover"
                >
                    <div>
                        <div class="popover-title">Confirm receiver deletion</div>
                        <div class="actions">
                            <el-button type="text" class="decline" @click="hideDeletePopover()">No</el-button>
                            <el-button type="text" class="accept" @click="removeAutomaticReceiver()">Yes</el-button>
                        </div>
                    </div>
                    <el-button
                        slot="reference"
                        type="danger"
                        class="gcmcn-danger-btn small"
                        @click="popOverOpenned = true"
                    >Delete</el-button>
                </el-popover>
            </div>
        </div>
        {{ ird.name }}
        <div class="details-title top-space">Taker</div>
        {{ relatedTaker ? relatedTaker.name : 'No taker' }}
        <div class="details-title top-space">Entity</div>
        <div class="ird-entity">
            <img :src="entity.logo">
            <div>{{ entity.display_name }}</div>
        </div>
        <div v-if="getHardwareType === 'zixi'">
            <div class="details-title top-space">ZIXI ID</div>
            {{ remoteId }}
        </div>
        <div class="details-title top-space">Latency</div>
        <span
            v-if="ird.latency === 0"
        >
            No latency
        </span>
        <span
            v-else
        >
            {{ ird.latency }}ms
        </span>
        <div class="details-title top-space">Encryption</div>
        <span
            v-if="ird.decryption_type === ''"
        >
            No encryption
        </span>
        <span
            v-else
        >
            {{ ird.decryption_type }}
        </span>
        <ns-loader
            ref="ns-loader"
            :toLoad="toLoad"
            :custom-scope="{ 'X-Entity-Uid': scopes}"
            @dataFetched="onDataFetched"
        >
            <ns-loader-spinner slot="loader"></ns-loader-spinner>
            <div slot="content" class="top-space">
                <ird-setting
                    :ird="ird"
                    :feeds="feeds"
                    :configurations="configurations"
                    :events="events"
                    :events-by-entity="eventsByEntity"
                    :entities="$store.getters.entities"
                    :parameters="{}"
                    :zixi-receiver="relatedZixireceiver"
                    :error-message="remoteIdFailureMessage"
                ></ird-setting>
            </div>
        </ns-loader>
        <div class="details-title top-space">AWS Region</div>
        {{ region.display_name }}
    </div>
</template>

<script>

import { IrdSetting } from 'gcmcn-common';
import NsLoader from 'fundation-app-vuejs/src/components/partials/ns-vue-loader';
import NsLoaderSpinner from '../../../partials/ns-loader-template.vue';
import { mapGetters } from 'vuex';
export default {

    components: {
        IrdSetting,
        NsLoader,
        NsLoaderSpinner,
    },

    props: {
        ird: {
            type: Object,
            required: true,
        },
    },

    data (){
        return {
            popOverOpenned: false,
            loading: false,
            feeds: [],
            configurations: [],
            events: [],
            toLoad: [
                {
                    model: 'feeds',
                    name: 'feeds',
                    filters: {
                        archived: false,
                        status__in: 'AVAILABLE,STARTING,RUNNING,PREPARING',
                    }
                },
                {
                    model: 'configurations',
                    name: 'configurations',
                    filters: {
                        archived: false,
                        cancelled: false,
                        finished: false,
                    }
                },
                {
                    model: 'events',
                    name: 'events',
                    filters: {
                        archived: false,
                    }
                },
            ],
        };
    },

    computed: {
        ...mapGetters([
            'entitiesByUid',
            'awsregionsByUid',
            'hwTypesByUid'
        ]),
        getHardwareType() {
            let hwType = this.hwTypesByUid(this.ird.hw_type_uid)
            return hwType.source_protocol_type;
        },
        remoteIdFailureMessage(){
            return "Unable to retrieve Zixi ID"
        },
        relatedZixireceiver (){
            return this.$store.getters.zixiReceivers.find((zixi) => zixi.ird_uid === this.ird.uid);
        },
        remoteId() {
            if (this.relatedZixireceiver.status === 'FAILED') {
                return this.remoteIdFailureMessage
            } else {
                return this.ird.remote_id
            }
        },
        canEdit(){
            return !["PENDING", "RUNNING"].includes(this.relatedZixireceiver.status)
        },
        scopes (){
            return this.ird.scopes.entity_uid;
        },

        entity (){
            return this.entitiesByUid(this.scopes);
        },
        region (){
            return this.awsregionsByUid(this.ird.region_uid);
        },

        eventsByEntity (){
            return {
                [this.scopes]: this.events.map(ev => ev.uid)
            };
        },
        relatedTaker (){
            return this.$store.getters.takers.find((t) => t.uid === this.ird.taker_uid);
        }
    },

    mounted (){
    },

    methods: {
        editDetails (){
            this.$emit('edit-ird');
        },
        onDataFetched (res){
            this.$set(this, 'events', res.events);
            this.$set(this, 'feeds', res.feeds);
            this.$set(this, 'configurations', res.configurations);
        },
        removeAutomaticReceiver (){
            // this.$confirm('This will delete the automatic receiver. Continue?', 'Warning', {
            //     confirmButtonText: 'Yes',
            //     cancelButtonText: 'No',
            //     type: 'warning'
            // }).then(() => {
                this.$store.dispatch('patchItem', {
                    item: {
                        archived: true,
                        url: this.ird.url
                    },
                    model: 'irds', 
                }).then(() => {
                    this.$emit('on-automatic-receiver-deleted');
                    this.$store.dispatch('fetchModelByName', 'irds');
                    this.$message({
                        type: 'success',
                        message: 'Delete completed'
                    });
                }).catch((e) => {
                    console.error(e);
                    this.$message({
                        type: 'error',
                        message: 'Error on automatic receiver delete'
                    });
                });
            // }).catch(() => {});

        },
        hideDeletePopover() {
            this.popOverOpenned = false;
            if (this.$refs['popover']) {
                this.$refs['popover'].showPopper = false;
            }
        },
    },
};
</script>

<style lang="scss">
.ird-entity{
    display: flex;
    align-items: center;
    margin-top: 20px;
    img{
        width: 80px;
    }
    div{
        margin-left: 1rem;
        font-size: 18px;
        font-weight: bold;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Receiver/Ird/irdDetails.vue